package one.healthium.update_food_preferences.domain.models

enum class FoodPreferenceStatus {
    Included,
    Excluded,
    Neutral,
}